import { render, staticRenderFns } from "./lunbo.vue?vue&type=template&id=b48ab4ec&scoped=true"
import script from "./lunbo.vue?vue&type=script&lang=js"
export * from "./lunbo.vue?vue&type=script&lang=js"
import style0 from "./lunbo.vue?vue&type=style&index=0&id=b48ab4ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48ab4ec",
  null
  
)

export default component.exports